// extracted by mini-css-extract-plugin
export var closeButton = "_23-3";
export var header = "_23-0";
export var link = "_23-1";
export var retryButton = "_23-2";